import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaEnvelope,
  FaBell,
  FaRegBell,
  FaClipboardList,
  FaSearch,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { LuNewspaper } from "react-icons/lu";
import { BsChatDots } from "react-icons/bs";
import { useMediaQuery } from "react-responsive";
import { useUser } from "../../context/UserContext";

const Navbar = React.forwardRef(
  (
    {
      toggleSidebar,
      notificationIconRef,
      setShowNotificationPane,
      accountIconRef,
      setShowAccountPane,
      profileImageUrl,
    },
    ref
  ) => {
    const [searchTerm, setSearchTerm] = useState("");
    const { workerUser, getWorkerVerificationDetailsById } = useUser();
    const [workerNotificationCount, setWorkerNotificationCount] = useState(0);
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [isSearchFocused, setIsSearchFocused] = useState(false);


    useEffect(() => {
      if (workerUser && workerUser.id) {
        const fetchWorkerNotifications = async () => {
          const verificationDetails = await getWorkerVerificationDetailsById(
            workerUser.id
          );
          if (verificationDetails) {
            setWorkerNotificationCount(
              verificationDetails.totalVerificationIssuesCount
            );
          }
        };
        fetchWorkerNotifications();
      }
    }, [workerUser, getWorkerVerificationDetailsById]);

    const handleNotificationClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (notificationIconRef.current) {
        const rect = notificationIconRef.current.getBoundingClientRect();
        setShowNotificationPane((prevState) => {
          if (prevState.show) {
            return { ...prevState, show: false };
          } else {
            return {
              show: true,
              top: isMobile ? rect.top : rect.bottom,
              left: rect.left + rect.width / 2,
              bottom: isMobile ? window.innerHeight - rect.top : null,
              iconWidth: rect.width,
            };
          }
        });
      }
    };

    const handleAccountClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (accountIconRef.current) {
        const rect = accountIconRef.current.getBoundingClientRect();
        setShowAccountPane((prevState) => ({
          show: !prevState.show,
          top: isMobile ? "auto" : rect.bottom + window.scrollY,
          bottom: isMobile ? window.innerHeight - rect.top : "auto",
          left: isMobile ? "auto" : rect.right - 250,
        }));
      }
    };

    const renderNavbarIcons = () => (
      <div className="navbar-icons-container">
        <div className="navbar-icons">
          <div className="menu-icons-wrapper">
            <Link className="navbar-icon" to="/account/ps-dashboard/">
              <div className="notification-icon-wrapper">
                <FaHome />
              </div>
              <span>Home</span>
            </Link>
            <Link className="navbar-icon" to="/account/ps-dashboard/job-listings">
              <div className="notification-icon-wrapper">
                <LuNewspaper />
              </div>
              <span>Jobs</span>
            </Link>

            {!isMobile && (
              <Link
                className="navbar-icon"
                onClick={handleNotificationClick}
                ref={notificationIconRef}
              >
                <div className="notification-icon-wrapper">
                  <FaRegBell />
                  {workerNotificationCount > 0 && (
                    <div className="notification-badge">
                      {workerNotificationCount > 99 ? "99+" : workerNotificationCount}
                    </div>
                  )}
                </div>
                <span>Updates</span>
              </Link>
            )}

            <Link className="navbar-icon" to="/account/ps-dashboard/inbox">
              <div className="notification-icon-wrapper">
                <BsChatDots />
              </div>
              <span>Chats</span>
            </Link>
          </div>
          <div className="account-icon-wrapper">
            <Link
              className={`navbar-icon account-icon ${isMobile ? "mobile" : ""}`}
              onClick={handleAccountClick}
              ref={accountIconRef}
            >
              <img
                src={profileImageUrl}
                alt="Profile"
                className="profile-image"
              />
              <span>
                Account
                {/* {isMobile ? (
                  <FaChevronUp className="chevron-icon" />
                ) : (
                  <FaChevronDown className="chevron-icon" />
                )} */}
              </span>
            </Link>
          </div>
        </div>
      </div>
    );


    return (
      <>
        <nav className="dashboard-navbar" ref={ref}>
          <div className="dashboard-navbar-controls">
            {!(isMobile && isSearchFocused) && (
              <div className="dashboard-navbar-logo">
                <a href="/">
                  <img
                    src="/images/dashboard_logo.png"
                    alt="Logo"
                    className="logo-image"
                  />
                </a>
              </div>
            )}

            <div
              className={`search-container ${isMobile && isSearchFocused ? "expanded" : ""
                }`}
            >
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
              />
            </div>

            {!isMobile && renderNavbarIcons()}
          </div>

          <div className="dashboard-navbar-logout">
            {isMobile && (
              <button
                className="navbar-icon notification-only"
                onClick={handleNotificationClick}
                ref={notificationIconRef}
              >
                <FaRegBell />
                {workerNotificationCount > 0 && (
                  <span className="notification-dot"></span>
                )}
              </button>
            )}

            <button className="hamburger-menu" onClick={toggleSidebar}>
              ☰
            </button>
          </div>

        </nav>

        {isMobile && <div className="bottom-navbar">{renderNavbarIcons()}</div>}
      </>
    );
  }
);

export default Navbar;
